import { useEffect } from 'react';
import { useLocation } from '@/features/routing';
import { ROUTES } from '@/features/routing/constants';

export const AppBackgroundController = () => {
  const pathname = useLocation();

  useEffect(() => {
    const useSecondaryBackground = ([ROUTES.Welcome, ROUTES.Login] as string[]).includes(pathname);

    // Change the background variant on the html tag.
    document.documentElement.setAttribute(
      'data-bg-variant',
      useSecondaryBackground ? 'secondary' : 'primary'
    );
  }, [pathname]);

  return null;
};
